import { render, staticRenderFns } from "./section_3.vue?vue&type=template&id=7f42ed7c&scoped=true&"
import script from "./section_3.vue?vue&type=script&lang=js&"
export * from "./section_3.vue?vue&type=script&lang=js&"
import style0 from "./section_3.vue?vue&type=style&index=0&id=7f42ed7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42ed7c",
  null
  
)

component.options.__file = "section_3.vue"
export default component.exports